import React from 'react';
import Homepage from '../components/pages/layout/Homepage';
import Events from '../components/pages/layout/Events';
import Event from '../components/pages/layout/Event';
import Host from '../components/pages/layout/Host';
import Locations from '../components/pages/layout/Locations';
import Location from '../components/pages/layout/Location';
import {MatomoListener} from '../config/matomo';

export default {
    'home': {
        path: '/',
        component: () => (
            <MatomoListener>
                {() => <Homepage /> }
            </MatomoListener>
        ),
    },
    'events': {
        path: '/events',
        component: () => (
            <MatomoListener>
                {() => <Events key={Date.now()} />}
            </MatomoListener>
        ),
    },
    'eventDetails': {
        path: '/events/:id',
        component: ({match}) => (
            <MatomoListener match={match}>
                {({match}) => <Event match={match} />}
            </MatomoListener>
        ),
    },
    'hostDetails': {
        path: '/hosts/:id',
        component: ({match}) => (
            <MatomoListener match={match}>
                {({match}) => <Host match={match} />}
            </MatomoListener>
        ),
    },
    'locations': {
        path: '/locations',
        component: () => (
            <MatomoListener>
                {() => <Locations key={Date.now()} />}
            </MatomoListener>
        ),
    },
    'locationDetails': {
        path: '/locations/:id',
        component: ({match}) => (
            <MatomoListener match={match}>
                {({match}) => <Location match={match} />}
            </MatomoListener>
        ),
    },
};
